var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBatteryQualification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.091,
    height: 49.914,
    viewBox: "0 0 59.091 49.914",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3524",
    "data-name": "Group 3524",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3412",
    "data-name": "Group 3412",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_613",
    "data-name": "Group 613"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_95",
    "data-name": "Rectangle 95",
    d: "M1.866,1.911V30.572H46.661V1.911H1.866M1.866,0H46.661a1.889,1.889,0,0,1,1.866,1.911V30.572a1.889,1.889,0,0,1-1.866,1.911H1.866A1.889,1.889,0,0,1,0,30.572V1.911A1.889,1.889,0,0,1,1.866,0Z",
    transform: "translate(0 4.846)",
    fill: "#c5ad7e",
    stroke: "#c5ad7e",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_612",
    "data-name": "Group 612",
    transform: "translate(9.495 12.935)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_90",
    "data-name": "Rectangle 90",
    width: 6.314,
    height: 1.263,
    transform: "translate(0 2.525)",
    fill: "#c5ad7e",
    stroke: "#c5ad7e",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_610",
    "data-name": "Group 610",
    transform: "translate(22.73 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_93",
    "data-name": "Rectangle 93",
    width: 1.263,
    height: 6.314,
    transform: "translate(2.525)",
    fill: "#c5ad7e",
    stroke: "#c5ad7e",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_94",
    "data-name": "Rectangle 94",
    width: 6.314,
    height: 1.263,
    transform: "translate(0 2.525)",
    fill: "#c5ad7e",
    stroke: "#c5ad7e",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_96",
    "data-name": "Rectangle 96",
    d: "M1.615,1.615V4.846H9.692V1.615H1.615M1.615,0H9.692a1.615,1.615,0,0,1,1.615,1.615V4.846A1.615,1.615,0,0,1,9.692,6.462H1.615A1.615,1.615,0,0,1,0,4.846V1.615A1.615,1.615,0,0,1,1.615,0Z",
    transform: "translate(3.231)",
    fill: "#c5ad7e",
    stroke: "#c5ad7e",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_97",
    "data-name": "Rectangle 97",
    d: "M1.615,1.615V4.846H9.692V1.615H1.615M1.615,0H9.692a1.615,1.615,0,0,1,1.615,1.615V4.846A1.615,1.615,0,0,1,9.692,6.462H1.615A1.615,1.615,0,0,1,0,4.846V1.615A1.615,1.615,0,0,1,1.615,0Z",
    transform: "translate(32.373)",
    fill: "#c5ad7e",
    stroke: "#c5ad7e",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3413",
    "data-name": "Group 3413",
    transform: "translate(30.537 18.664)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1634",
    "data-name": "Rectangle 1634",
    width: 28.304,
    height: 31,
    rx: 5,
    fill: "#f6f8fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "award",
    d: "M19.719,27h-.08a.834.834,0,0,1-.438-.118.8.8,0,0,1-.3-.329l-4.425-8.042c-.159.019-.3.031-.436.039s-.278.014-.438.014c-.178,0-.334,0-.477-.014s-.306-.021-.477-.039L8.3,26.551a.8.8,0,0,1-.3.329A.834.834,0,0,1,7.555,27H7.5a.924.924,0,0,1-.463-.171.768.768,0,0,1-.279-.382L5.3,22.412l-4.266.949a.7.7,0,0,1-.219.036.721.721,0,0,1-.258-.049.753.753,0,0,1-.372-.3A.779.779,0,0,1,0,22.609a.7.7,0,0,1,.1-.461L5.091,13.1a9.169,9.169,0,0,1-.82-3.823A9.038,9.038,0,0,1,5,5.668,9.329,9.329,0,0,1,9.967.725a9.452,9.452,0,0,1,7.26,0,9.288,9.288,0,0,1,2.955,1.99,9.753,9.753,0,0,1,2,2.953,8.931,8.931,0,0,1,.741,3.614,8.757,8.757,0,0,1-.211,1.938,10.426,10.426,0,0,1-.584,1.806l4.956,9.123a.713.713,0,0,1,.107.461.922.922,0,0,1-.186.461.793.793,0,0,1-.37.277.721.721,0,0,1-.258.049.7.7,0,0,1-.219-.036l-4.268-.949-1.456,4.034a.768.768,0,0,1-.279.382.893.893,0,0,1-.436.171Zm1.4-12.26a9.671,9.671,0,0,1-2.16,2.11,9.435,9.435,0,0,1-2.742,1.345L19.48,24.1l1.059-2.98a.98.98,0,0,1,.411-.448.774.774,0,0,1,.388-.106.878.878,0,0,1,.209.026L24.7,21.3l-3.577-6.565ZM5.856,20.566a.774.774,0,0,1,.388.106.974.974,0,0,1,.411.448l1.059,2.953,3.18-5.906A9.529,9.529,0,0,1,8.2,16.849,9.168,9.168,0,0,1,6.1,14.791L2.495,21.3l3.153-.711A.878.878,0,0,1,5.856,20.566ZM13.6,1.688a7.3,7.3,0,0,0-2.967.607A8.106,8.106,0,0,0,8.2,3.928,7.565,7.565,0,0,0,6.563,6.34a7.539,7.539,0,0,0,0,5.881A7.564,7.564,0,0,0,8.2,14.634a8.106,8.106,0,0,0,2.426,1.634,7.531,7.531,0,0,0,5.922,0,7.884,7.884,0,0,0,2.424-1.634,7.645,7.645,0,0,0,1.631-2.412,7.559,7.559,0,0,0,0-5.881,7.645,7.645,0,0,0-1.631-2.412,7.884,7.884,0,0,0-2.424-1.634A7.337,7.337,0,0,0,13.6,1.688Z",
    transform: "translate(0.293 1.664)",
    fill: "#c5ad7e",
    stroke: "#c5ad7e",
    strokeWidth: 0.2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBatteryQualification);
export default __webpack_public_path__ + "static/media/icon_battery_qualification.e9f03e94df3c891904faff1feba66c0f.svg";
export { ForwardRef as ReactComponent };